import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SavedEventsProvider } from './contexts/SavedEventsContext';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Calendar from './pages/Calendar';
import About from './pages/About';
import Login from './pages/Login';
import Signup from './pages/Signup';
import SubmitEvent from './pages/SubmitEvent';
import Admin from './pages/Admin';
import Dashboard from './pages/Dashboard';
import Scheduler from './pages/Scheduler';
import Settings from './pages/Settings';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SavedEventsProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/events" element={<Calendar />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/scheduler" element={<Scheduler />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/submit" element={<SubmitEvent />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
        </SavedEventsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
